const roles = [
    { label: 'Admin', value: 'ADMIN' },
    { label: 'User', value: 'USER' },
];

export default roles;
